import { Menu } from "lucide-react";

import { Logo } from "@/components/shared/logo";
import { useSidebar } from "@/hooks/use-sidebar";
import { useTranslation } from "@/i18n";
import { WorkspaceSelector } from "./workspace-selector";

export function TopbarMobile() {
  const { openMobile } = useSidebar();
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-10 flex h-14 items-center justify-between border-b border-ocean-100 bg-white px-4 tablet:hidden">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={openMobile}
          className="rounded-md p-1.5 text-ocean-800 transition-colors hover:bg-ocean-100"
          aria-label={t("shared.topbar.openMenu")}
        >
          <Menu size={20} />
        </button>
        <Logo size="sm" />
      </div>
      <div className="ml-3 max-w-[180px] flex-1">
        <WorkspaceSelector compact />
      </div>
    </header>
  );
}
